import 'styles/join-us/values-gallery.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import LeftArrow from '!svg-react-loader?!images/icons/icon-left-arrow.svg';
import RightArrow from '!svg-react-loader?!images/icons/icon-right-arrow.svg';

import React from 'react';
import { Carousel } from 'react-responsive-carousel';

export default class ValuesGallery extends React.Component {
  render() {
    return (
      <Carousel
        className="ValuesGallery"
        emulateTouch={true}
        showIndicators={false}
        showThumbs={false}
        statusFormatter={() => ''}
      >
        {this.props.values.map(value => (
          <ValuesGalleryItem key={value.title} value={value} />
        ))}
      </Carousel>
    );
  }
}

class ValuesGalleryItem extends React.Component {
  render() {
    const value = this.props.value;

    return (
      <div className="ValuesGalleryItem">
        <div className="new-h2 flat-blue ValuesGalleryItem__title">
          {value.title}
        </div>
        <div className="new-text navy center ValuesGalleryItem__text">
          {value.text}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/join-us/components/ValuesGallery.js